import { useQuery } from '@tanstack/react-query';
import { parseRawData } from '../resource-base/adapters/AdapterUtils';
import { get } from '../resource-base/APIVersion1';
import {
    MaestraSignalApplicationInformationPayloadSchema,
} from '../resources/maestraSignalApplicationInformationPayload';

export const useProCeedApplicationInformation = () => {
    return useQuery({
        queryKey: ['PROCEED_APPLICATION_INFO'],
        queryFn: () =>
            get('system-info', true).then((result) => {
                if (result.status !== 200) {
                    throw new Error('Validation Entry Details could not be found');
                }
                return result
                    .json()
                    .then((rawData) => parseRawData(rawData, MaestraSignalApplicationInformationPayloadSchema));
            }),
        refetchInterval: false,
        staleTime: Number.POSITIVE_INFINITY,
    });
};